// Both values are set by scripts/build.js and inlined by Parcel. They are undefined for
// `yarn start` and for any build that did not go through `yarn build`.
export const buildTimestamp = process.env.REACT_APP_BUILD_TIMESTAMP
export const buildCommit = process.env.REACT_APP_BUILD_COMMIT

export const hasBuildInfo = (info) => Boolean(info.timestamp || info.commit)

export function formatBuildLabel(version, info, expanded) {
  const details = [info.timestamp, info.commit].filter(Boolean)

  if (!expanded || details.length === 0) {
    return `Version ${version}`
  }

  return `Version ${version} - ${details.join(' - ')}`
}
